<template>
  <div class="container">
    <app-page-search :title="title"></app-page-search>
    <app-spinner v-if="loading"></app-spinner>
    <div v-else>
      <div class="filter">
        <div
          v-for="(year, idx) in years"
          :class="{ 'active': activeYears.includes(year), 'selected': selectedYear === year }"
          :key="idx"
          class="circle"
          @click="selectedYear = year">
          <span class="circle-line"></span>
          <div class="year" v-text="year"></div>
        </div>
      </div>

      <div class="mobile-filter">
        <v-select
          :options="years"
          v-model="selectedYear"
          :searchable="true">
        </v-select>
      </div>

      <div class="archive-list">
        <div
          v-for="block in blocks"
          v-if="block.categories"
          :class="{ active: openedBlock === block.guid }"
          :key="block.guid"
          class="block"
          @click="toggleBlock(block.guid)"
        >

          <div class="category">
            <img :src="block.icon_url" alt="" class="category__icon">

            <h3 class="text-sm category__title" v-text="block.title"></h3>

            <svg class="category__icon-play">
              <use xlink:href="#play"></use>
            </svg>
          </div>

          <div v-show="openedBlock === block.guid" class="competencies">
            <div
              v-for="competence in block.categories"
              :class="{ active: openedCompetence === competence.guid }"
              :key="competence.guid"
              class="competence"
              @click.stop="toggleCompetence(competence)"
            >
              <div class="competence-name">
                <div class="competence__title" v-text="competence.title"></div>
                <div class="competence__translation" v-text="competence.alt"></div>
              </div>

              <div v-show="competence.docs && competence.docs.length && openedCompetence === competence.guid"
                   class="competence-documents">
                <app-document-list :documents="getFilesByType(competence.docs, 'main')" />
                <app-document-list :documents="getFilesByType(competence.docs, 'application')"
                                   type="application" />
                <app-document-list :documents="getFilesByType(competence.docs, 'infra_docs')"
                                   type="infra_docs" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { AppPageSearch, AppDocumentList, AppSpinner } from "@/components";
import { loadYears } from "@/api";
import { loadCompetenciesWithDocs } from "@/api/competencies";

export default {
  name: "Archive",
  components: { AppPageSearch, AppDocumentList, AppSpinner },

  data: () => ({
    title: "Архив требований",
    years: [],
    activeYears: 0,
    selectedYear: null,
    openedBlock: "",
    openedCompetence: "",
    blocks: [],
    loading: true
  }),

  watch: {
    activeYears(newVal) {
      this.loadCompetencies(newVal[newVal.length - 1]);
    },
    selectedYear(newVal) {
      this.loadCompetencies(newVal);
    }
  },
  async created() {
    const response = await loadYears();
    this.years = [...response.archive, response.active].map(y => y.toString());
    this.activeYears = response.archive.map(y => y.toString());
    this.selectedYear = response.active;

    this.loading = false;
  },

  methods: {
    async loadCompetencies(year) {
      this.blocks = await loadCompetenciesWithDocs({ year });
    },
    toggleBlock(id) {
      if (this.openedBlock !== id) {
        this.openedBlock = id;
        return;
      }
      this.openedBlock = this.openedBlock ? null : id;
    },

    toggleCompetence(competence) {
      if (!competence.docs) return;
      if (this.openedCompetence !== competence.guid) {
        this.openedCompetence = competence.guid;
        return;
      }
      this.openedCompetence = this.openedCompetence ? null : competence.guid;
    },

    getFilesByType(documents, type) {
      return documents && documents.filter(f => f.type === type);
    }
  }
};
</script>
<style lang="scss" scoped>
.archive-list {
  padding-top: 45px;
}

.loader {
  top: 50%;
}

.block {
  border: 1px solid #e5e5e5;
  padding: 30px 42px;
  margin-bottom: 27px;
  cursor: pointer;

  &.active {
    .category__icon-play {
      transform: rotate(90deg);
    }
  }

  .documents-list.app {
    padding-left: 0;
  }
}

.category {
  display: flex;
  align-items: center;

  &__icon {
    width: 39px;
    min-width: 39px;
    height: 38px;
    margin-right: 30px;
  }
  &__icon-play {
    width: 10px;
    height: 12px;
    align-self: center;
  }

  &__title {
    flex: 3;
    margin-bottom: 0;
    align-self: center;
    font-weight: 500;
  }
}

.competencies {
  padding-top: 65px;
}

.competence {
  &.active {
    background-color: #f5f5f5;
    padding: 30px 35px 5px 35px;
    margin-top: 20px;
    margin-bottom: 40px;

    .competence-name {
      font-size: 18px;
      line-height: 23px;
      font-weight: bold;
      margin-bottom: 0;
    }

    .documents-list {
      padding-top: 0;
    }
  }
}

.competence-documents {
  padding-top: 40px;
  background-color: #f5f5f5;

  .documents-list:not(.empty) + .documents-list:not(.empty) {
    padding-top: 40px;
    border-top: 1px solid #9a9a9a;
  }
}

.competence-name {
  display: flex;
  font-size: 15px;
  line-height: 30px;
  font-weight: 300;
  margin-bottom: 15px;
  width: fit-content;

  .competence:not(.active) &:hover {
    background-color: #1c3b8d;
    border-radius: 5px;
    margin-left: -10px;
    padding-left: 10px;
    padding-right: 10px;

    .competence__title {
      color: #fff;
    }
    .competence__translation {
      color: #6d9ae8;
    }
  }

  .competence__title {
    margin-right: 5px;
  }
  .competence__translation {
    color: #9c9c9c;
  }
}

.filter {
  display: flex;
  align-items: center;
  padding: 50px 0;
  padding-left: 3px;

  .circle {
    width: 26px;
    height: 26px;
    margin-right: 40px;
    border: 1px solid #c7c7c7;
    border-radius: 50%;
    position: relative;
    cursor: pointer;

    .circle-line {
      position: absolute;
      top: 50%;
      left: 29px;
      height: 1px;
      width: 40px;
      background-color: #c7c7c7;
    }

    .year {
      position: absolute;
      top: 40px;
      left: -3px;
      font-size: 15px;
      color: #c7c7c7;
    }

    &.active {
      width: 26px;
      height: 26px;
      border-color: #1c3b8d;
      background-color: #1c3b8d;

      .circle-line {
        left: 25px;
        z-index: -1;
        background-color: #1c3b8d;
      }

      .year {
        color: #1c3b8d;
        font-weight: bold;
      }

      &.selected {
        position: relative;
        box-shadow: 0 0 0 3px #fff, 0 0 0 6px #eb5757;
      }
    }

    &:last-child {
      .circle-line {
        display: none;
      }
    }
  }
}

.mobile-filter {
  padding-top: 20px;
}

@include media-breakpoint-up(sm) {
  .mobile-filter {
    display: none;
  }
}
@include media-breakpoint-down(sm) {
  .filter {
    display: none;
  }

  .block {
    padding: 25px;
    padding-right: 15px;

    &.active {
      padding-right: 0;
      padding-left: 0;

      .category {
        padding-left: 25px;
      }

      .category__icon-play {
        margin-right: 10px;
      }
    }
  }

  .category {
    &__icon {
      margin-right: 25px;
    }

    &__title {
      flex: 0 68%;
    }
  }
  .competence-name {
    flex-wrap: wrap;
    margin-bottom: 0;

    .competence__title {
      flex: 1 1 100%;
    }
  }

  .competence {
    padding-left: 25px;

    &.active {
      padding-left: 25px;
      padding-right: 25px;
      .competence-name {
        line-height: 25px;
      }
    }
  }
}
</style>
